// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lZTzx","title":"styles_title__IzOlG"};